// Local translations
export const T = {
  en_GB: {
    admin: "Admin",
    tenants: "Tenants",
    tenantsDescription: "Manage organizations and their authentication methods",
  },
  nb_NO: {
    admin: "Admin",
    tenants: "Organisasjoner",
    tenantsDescription: "Administrer organisasjoner og deres autentiseringsmetoder",
  },
} as const;
